import { CommonModule } from '@angular/common'
import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { ResizeHandleModule } from '@helios/generic-components'
import { NgbNavModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import {
  GridWrapperModule,
  TableLayoutModule,
} from '@northfork/ag-grid-angular'
import { ButtonModule, LoaderModule } from '@northfork/ng-basics'
import { DevToolsHttpComponent } from './components/dev-tools-http/dev-tools-http.component'
import { DevtoolsGridComponent } from './components/devtools-grid/devtools-grid.component'
import { DevtoolsPanelComponent } from './devtools-panel.component'
import { DevtoolsHttpInterceptor } from './interceptors/devtools-http.interceptor'

@NgModule({
  imports: [
    CommonModule,
    TableLayoutModule,
    GridWrapperModule,
    LoaderModule,
    ButtonModule,
    NgbTooltipModule,
    ResizeHandleModule,
    NgbNavModule,
  ],
  declarations: [
    DevtoolsPanelComponent,
    DevtoolsGridComponent,
    DevToolsHttpComponent,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DevtoolsHttpInterceptor,
      multi: true,
    },
  ],
  exports: [DevtoolsPanelComponent],
})
export class DevtoolsModule {}

export { DevtoolsPanelComponent }
